module.exports = __webpack_public_path__ + "img/proyecto_13.2825f3b0.webp";